import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import LoadingNavBar from '../navbar/LoadingNavBar';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const CookiePolicy = () => {
  const { t } = useTranslation();
  
  const colors = {
    background: "#ffffff",
    primary: "#102a43",
    secondary: "#39ace7",
    textPrimary: "#212529",
    textSecondary: "#495057",
  };

  return (
    <>
      <LoadingNavBar showLoginButton={true} />
      <Box
        sx={{
          background: colors.background,
          color: colors.textPrimary,
          minHeight: '100vh',
          py: 15,
          px: { xs: 3, md: 6 },
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: colors.primary, textAlign: 'center' }}>
            {t(StringKeys.COOKIE_POLICY)}
          </Typography>
          <Typography variant="subtitle1" gutterBottom sx={{ textAlign: 'center', color: colors.textSecondary }}>
            {t(StringKeys.COOKIE_POLICY_EFFECTIVE_DATE)}
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section 1 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.COOKIE_POLICY_INTRO_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_INTRO_CONTENT)}
          </Typography>

          {/* Section 2 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.COOKIE_POLICY_USAGE_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_USAGE_CONTENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_USAGE_LIST)}
          </Typography>

          {/* Section 3 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.COOKIE_POLICY_TYPES_SECTION)}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: colors.secondary, mt: 2 }}>
            a. {t(StringKeys.COOKIE_POLICY_SESSION_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_SESSION_CONTENT)}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: colors.secondary, mt: 2 }}>
            b. {t(StringKeys.COOKIE_POLICY_PERSISTENT_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_PERSISTENT_CONTENT)}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: colors.secondary, mt: 2 }}>
            c. {t(StringKeys.COOKIE_POLICY_FIRST_PARTY_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_FIRST_PARTY_CONTENT)}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: colors.secondary, mt: 2 }}>
            d. {t(StringKeys.COOKIE_POLICY_THIRD_PARTY_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_THIRD_PARTY_CONTENT)}
          </Typography>

          {/* Section 4 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.COOKIE_POLICY_MANAGING_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_MANAGING_CONTENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_MANAGING_NOTE)}
          </Typography>

          {/* Section 5 */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.COOKIE_POLICY_CHANGES_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.COOKIE_POLICY_CHANGES_CONTENT)}
          </Typography>

          {/* Contact Section - Commented out for now
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.COOKIE_POLICY_CONTACT_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.CONTACT)}:
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: colors.secondary }}>
            {t(StringKeys.EMAIL)}: {t(StringKeys.COOKIE_POLICY_CONTACT_EMAIL)}
            <br />
            {t(StringKeys.PHONE)}: {t(StringKeys.COOKIE_POLICY_CONTACT_PHONE)}
          </Typography> */}
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default CookiePolicy;
